module.exports = __webpack_public_path__ + "static/media/bq_rov.ce950e07.png";